/**
 * Mayceline cart drawer — reliable CLOSE (X / underlay / Escape).
 * Root cause addressed with mayceline-cart-fast.js heal-loop fix:
 * theme build fires theme:product:added after refresh and re-opens the drawer.
 * This file makes close immediate and blocks that reopen race after user close.
 * Does not touch qty collapse, watch upsell, or Trustpilot CSS.
 */
(function () {
  'use strict';

  if (window.__maycelineCartCloseBound) return;
  window.__maycelineCartCloseBound = true;

  var USER_CLOSE_GUARD_MS = 2500;
  var userClosedAt = 0;

  function drawerEl() {
    return document.querySelector('cart-drawer');
  }

  function isOpen(d) {
    return !!(d && d.classList.contains('is-open'));
  }

  function markUserClose() {
    userClosedAt = Date.now();
  }

  function clearUserCloseGuard() {
    userClosedAt = 0;
  }

  function closeNow() {
    var d = drawerEl();
    if (!d || !isOpen(d)) return;
    markUserClose();
    try {
      if (typeof d.closeCartDrawer === 'function') {
        d.closeCartDrawer();
        return;
      }
    } catch (err) {}
    d.classList.add('is-closing');
    d.classList.remove('is-open');
    d.cartDrawerIsOpen = false;
    document.dispatchEvent(new CustomEvent('theme:cart-drawer:close', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
    window.setTimeout(function () {
      d.classList.remove('is-closing');
    }, 320);
  }

  function isCloseControl(el) {
    if (!el || !el.closest) return null;
    return el.closest('[data-cart-drawer-close]') || null;
  }

  function isUnderlay(el) {
    if (!el || !el.closest) return null;
    return (
      el.closest('[data-drawer-underlay]') ||
      el.closest('.drawer__underlay') ||
      null
    );
  }

  // pointerdown = immediate on phone (avoids missed / delayed click)
  document.addEventListener(
    'pointerdown',
    function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      var d = drawerEl();
      if (!isOpen(d)) return;
      if (isCloseControl(e.target)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        closeNow();
        return;
      }
      if (isUnderlay(e.target)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        closeNow();
      }
    },
    true
  );

  // click fallback (keyboard activation / browsers without pointer events)
  document.addEventListener(
    'click',
    function (e) {
      var d = drawerEl();
      if (!isOpen(d)) return;
      if (isCloseControl(e.target) || isUnderlay(e.target)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        closeNow();
      }
    },
    true
  );

  // Escape anywhere while drawer open (theme only listens on the drawer node)
  document.addEventListener(
    'keydown',
    function (e) {
      if (e.key !== 'Escape' && e.code !== 'Escape') return;
      if (!isOpen(drawerEl())) return;
      e.preventDefault();
      closeNow();
    },
    true
  );

  document.addEventListener('theme:cart-drawer:close', function () {
    markUserClose();
  });

  // Intentional opens must clear the guard
  document.addEventListener('theme:cart-drawer:open', clearUserCloseGuard);
  document.addEventListener('theme:cart-drawer:show', clearUserCloseGuard);
  document.addEventListener('theme:cart:toggle', clearUserCloseGuard);
  document.addEventListener('theme:product:add', clearUserCloseGuard);
  document.addEventListener('theme:cart:add', clearUserCloseGuard);

  /**
   * Theme CartDrawer.openCartDrawerOnProductAdded re-opens after every getCart/build
   * (theme:product:added). Block that only for a short window after user close.
   * Do NOT patch openCartDrawer — cart icon / ATC must keep working.
   */
  function patchCartDrawer() {
    var Ctor = customElements.get('cart-drawer');
    if (!Ctor || !Ctor.prototype || Ctor.prototype.__mayClosePatched) return;
    Ctor.prototype.__mayClosePatched = true;

    var orig = Ctor.prototype.openCartDrawerOnProductAdded;
    if (typeof orig !== 'function') return;
    Ctor.prototype.openCartDrawerOnProductAdded = function () {
      if (Date.now() - userClosedAt < USER_CLOSE_GUARD_MS) return;
      return orig.apply(this, arguments);
    };
  }

  if (customElements.get('cart-drawer')) patchCartDrawer();
  else customElements.whenDefined('cart-drawer').then(patchCartDrawer);
})();
